import baseapi from "./baseAPI";
import {successMesg, errorMesg} from "./../Pages/Toaster";

export const userRegistrationAPI = async (params, setLoading, navigate) =>{

    setLoading(true);
    
    try
    {
        const response = await baseapi.post('api/signup', params);

        console.log("Data saved successfully", response);
        setLoading(false);

        if(response.data.code === 200)
        {
            console.log("Here Step 1");
            successMesg(response.data.mesg);
            //resetUserForm();
            navigate('/sign-in');
        }
        else if(response.data.code === 400)
        {
            console.log("error message====" + response.data.mesg);
            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setLoading(false);
        errorMesg(error.data.mesg);
    }

}

export const userLoginAPI = async (params, setBtnLoading, navigate, setUser, setToken) =>{

    setBtnLoading(true);

    try
    {
        const response = await baseapi.post('api/login', params);

        console.log("Data saved successfully", response);
        setBtnLoading(false);

        if(response.data.code === 200)
        {
            console.log("Here Step 1");
            //successMesg(response.data.mesg);            
            

            setToken(response.data.cpmstoken);
            setUser(response.data.data);

            UserDeviceTrackAPI(response.data.data.id);

            switch(response.data.data.role_id)
            {
                case 1:
                    navigate('/admin/dashboard');
                    break;
                case 2:
                    navigate('/sales/dashboard');
                    break;
                case 3:
                    navigate('/caller/dashboard');
                    break;
                case 4:
                    navigate('/team/dashboard');
                    break;
                case 5:
                    navigate('/publisher/dashboard');
                    break;
                case 7:
                    navigate('/marketing/dashboard');
                    break;
                default:
                    navigate("/");
            }

            
        }
        else if(response.data.code === 400)
        {
            console.log("error message=====" + response.data.mesg);
            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setBtnLoading(false);
        //errorMesg(error.data.mesg);
    }
    
}

export const forgotPasswordAPI = async (params, setBtnLoading, navigate, resetForm) =>{

    setBtnLoading(true);
    
    try
    {
        const response = await baseapi.post('api/password/email', params);

        console.log("Data saved successfully", response);
        setBtnLoading(false);

        if(response.data.code == 200)
        {
            console.log("Here Step 1");
            successMesg(response.data.mesg);
            resetForm();
            //navigate('/sign-in');
        }
        else if(response.data.code == 400)
        {
            console.log("Here Step 2");
            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setBtnLoading(false);
        errorMesg(error.data.mesg);
    }
}

export const resetPasswordAPI = async (params, setBtnLoading, navigate) =>{

    setBtnLoading(true);
    
    try
    {
        const response = await baseapi.post('api/password/reset', params);

        console.log("Data saved successfully", response);
        setBtnLoading(false);

        if(response.data.code == 200)
        {
            console.log("Here Step 1");
            successMesg(response.data.mesg);
            //resetUserForm();
            navigate('/sign-in');
        }
        else if(response.data.code == 400)
        {
            console.log("Here Step 2");
            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setBtnLoading(false);
        errorMesg(error.data.mesg);
    }
}

export const UserDeviceTrackAPI = async (userid) =>{
    try
    {
        let platform = null;

        if (navigator.userAgentData) 
        {
            platform = navigator.userAgentData.platform; 
            // e.g. "Windows", "macOS", "Android"
        } 
        else 
        {
            // fallback (old browsers)
            platform = navigator.platform; 
        }

        const params = {
                        url: window.location.href,
                        referrer: document.referrer,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        navigator: {
                            userAgent: navigator.userAgent,
                            platform: platform,
                            language: navigator.language
                        },
                        userid: userid,
                        
        };

        const response = await baseapi.post('api/save-device-data', params);

        console.log("Data saved successfully", response);
        

        if(response.data.code == 200)
        {
            console.log("Device data saved");
            //successMesg(response.data.mesg);
            
        }
        else if(response.data.code == 400)
        {
            console.log("Device data not saved");
            //errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in save user device data:", error);
        //errorMesg(error.data.mesg);
    }
}



